import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_WorkHub.scss';
import { ModuleFE_WorkHub } from '../../_module/index.js';
import { Component_WorkHub_Header } from '../Component_WorkHub_Header/Component_WorkHub_Header.js';
import { Component_WorkHub_TabContent } from '../Component_WorkHub_TabContent/Component_WorkHub_TabContent.js';
import { BadImplementationException } from '@nu-art/ts-common';
export class Component_WorkHub extends ComponentSync {
    //######################### Life Cycle #########################
    __onWorkHubTabsUpdated = () => {
        this.setState({
            items: ModuleFE_WorkHub.tabs.get(),
        });
    };
    __onWorkHubTabSelected = () => {
        this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.noTabsMessage = nextProps.noTabsMessage;
        state.items = ModuleFE_WorkHub.tabs.get();
        return state;
    }
    //######################### Render #########################
    render() {
        return _jsx(LL_V_L, { className: 'c__work-hub', children: this.render_Content() });
    }
    render_Content = () => {
        if (!this.state.items.length)
            return _jsx("div", { className: 'c__work-hub__no-tabs-message', children: this.state.noTabsMessage });
        const selectedTab = ModuleFE_WorkHub.tabs.getSelected();
        if (!selectedTab)
            throw new BadImplementationException('Has tabs but no selected tab!');
        return _jsxs(_Fragment, { children: [_jsx(Component_WorkHub_Header, { items: this.state.items, selectedTabId: selectedTab.id }), _jsx(Component_WorkHub_TabContent, { tab: selectedTab })] });
    };
}
//# sourceMappingURL=Component_WorkHub.js.map